export interface Product {
  id: string;
  slug: string;
  name: string;
  short_description: string;
  price: number;
  original_price?: number;
  currency: 'TRY' | 'USD' | 'EUR';
  category_id: string;
  category_name: string;
  image_url: string;
  gallery: string[];
  badge?: string;
  in_stock: boolean;
  stock_count: number;
  rating: number;
  review_count: number;
  roast_level?: string;
  origin?: string;
  weight?: string;
}

export const mockProducts: Product[] = [
  {
    id: '1',
    slug: 'etiyopya-yirgacheffe-filtre',
    name: 'Etiyopya Yirgacheffe',
    short_description: 'Çiçeksi ve meyvemsi notlarıyla yüksek rakım single origin filtre kahve',
    price: 489,
    original_price: 599,
    currency: 'TRY',
    category_id: '1',
    category_name: 'Filtre Kahve',
    image_url: 'https://public.readdy.ai/ai/img_res/b6a390a37c22a13d6048670679d91511.jpg',
    gallery: [],
    badge: 'İndirimli',
    in_stock: true,
    stock_count: 48,
    rating: 4.9,
    review_count: 127,
    roast_level: 'Açık Kavrum',
    origin: 'Etiyopya',
    weight: '250g',
  },
  {
    id: '2',
    slug: 'kolombiya-huila-espresso',
    name: 'Kolombiya Huila',
    short_description: 'Karamel ve fındık tonlarıyla dengeli, velvety bir espresso',
    price: 449,
    currency: 'TRY',
    category_id: '2',
    category_name: 'Espresso',
    image_url: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20bag%20packaging%20Colombia%20Huila%20dark%20kraft%20bag%20elegant%20minimal%20product%20photography%20white%20background%20artisan%20roastery%20small%20batch%20roasted&width=600&height=600&seq=prod2&orientation=squarish',
    gallery: [],
    badge: 'Çok Satan',
    in_stock: true,
    stock_count: 65,
    rating: 4.8,
    review_count: 203,
    roast_level: 'Orta Kavrum',
    origin: 'Kolombiya',
    weight: '250g',
  },
  {
    id: '3',
    slug: 'brezilya-santos-french-press',
    name: 'Brezilya Santos',
    short_description: 'Çikolata ve fındık notalarıyla dolgun gövdeli French Press kahvesi',
    price: 389,
    currency: 'TRY',
    category_id: '1',
    category_name: 'Filtre Kahve',
    image_url: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20bag%20packaging%20Brazil%20Santos%20beige%20kraft%20bag%20elegant%20minimal%20product%20photography%20white%20clean%20background%20artisan%20roastery%20warm%20tones&width=600&height=600&seq=prod3&orientation=squarish',
    gallery: [],
    in_stock: true,
    stock_count: 92,
    rating: 4.7,
    review_count: 88,
    roast_level: 'Orta-Koyu Kavrum',
    origin: 'Brezilya',
    weight: '250g',
  },
  {
    id: '4',
    slug: 'kenya-aa-pourover',
    name: 'Kenya AA',
    short_description: 'Parlak asidite ve böğürtlen notalarıyla ödüllü Kenya single origin',
    price: 529,
    currency: 'TRY',
    category_id: '1',
    category_name: 'Filtre Kahve',
    image_url: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20bag%20packaging%20Kenya%20AA%20black%20elegant%20bag%20minimal%20product%20photography%20white%20background%20artisan%20specialty%20roastery%20wine%20red%20accents&width=600&height=600&seq=prod4&orientation=squarish',
    gallery: [],
    badge: 'Yeni',
    in_stock: true,
    stock_count: 34,
    rating: 4.9,
    review_count: 56,
    roast_level: 'Açık Kavrum',
    origin: 'Kenya',
    weight: '250g',
  },
  {
    id: '5',
    slug: 'cold-brew-blend',
    name: 'Cold Brew Blend',
    short_description: 'Soğuk demlemede mükemmel denge için özel harmanlanmış blend',
    price: 549,
    currency: 'TRY',
    category_id: '3',
    category_name: 'Cold Brew',
    image_url: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20bag%20packaging%20cold%20brew%20blend%20dark%20navy%20bag%20elegant%20minimal%20product%20photography%20white%20background%20artisan%20roastery%20modern%20design&width=600&height=600&seq=prod5&orientation=squarish',
    gallery: [],
    in_stock: true,
    stock_count: 28,
    rating: 4.8,
    review_count: 74,
    roast_level: 'Orta-Koyu Kavrum',
    origin: 'Blend',
    weight: '250g',
  },
  {
    id: '6',
    slug: 'espresso-italiano-blend',
    name: 'Espresso Italiano',
    short_description: 'Geleneksel İtalyan usulü, yoğun crema ve koyu çikolata aroması',
    price: 399,
    currency: 'TRY',
    category_id: '2',
    category_name: 'Espresso',
    image_url: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20bag%20packaging%20Italian%20espresso%20blend%20dark%20red%20elegant%20bag%20minimal%20product%20photography%20white%20clean%20background%20artisan%20roastery%20classic%20design&width=600&height=600&seq=prod6&orientation=squarish',
    gallery: [],
    in_stock: true,
    stock_count: 110,
    rating: 4.6,
    review_count: 189,
    roast_level: 'Koyu Kavrum',
    origin: 'Blend',
    weight: '250g',
  },
  {
    id: '7',
    slug: 'guatemala-antigua-filter',
    name: 'Guatemala Antigua',
    short_description: 'Baharatlı ve bitter çikolata notalarıyla volkanik toprak kökenli',
    price: 469,
    currency: 'TRY',
    category_id: '1',
    category_name: 'Filtre Kahve',
    image_url: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20bag%20packaging%20Guatemala%20Antigua%20terracotta%20earthy%20tones%20elegant%20minimal%20product%20photography%20white%20background%20artisan%20roastery%20natural%20design&width=600&height=600&seq=prod7&orientation=squarish',
    gallery: [],
    in_stock: true,
    stock_count: 41,
    rating: 4.7,
    review_count: 63,
    roast_level: 'Orta Kavrum',
    origin: 'Guatemala',
    weight: '250g',
  },
  {
    id: '8',
    slug: 'baslangic-seti',
    name: 'Başlangıç Seti',
    short_description: '3 farklı origin ile kahve yolculuğuna başlamak için mükemmel hediye seti',
    price: 999,
    original_price: 1347,
    currency: 'TRY',
    category_id: '4',
    category_name: 'Set & Hediye',
    image_url: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20gift%20set%20three%20coffee%20bags%20elegant%20gift%20box%20packaging%20minimal%20white%20background%20artisan%20roastery%20kraft%20paper%20ribbon%20luxury%20presentation&width=600&height=600&seq=prod8&orientation=squarish',
    gallery: [],
    badge: 'Hediye',
    in_stock: true,
    stock_count: 18,
    rating: 5.0,
    review_count: 42,
    weight: '3×250g',
  },
];
